// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"2596":"3b9d1622","5279":"6c44d60f","6925":"2c386607"}[chunkId] || chunkId) + "." + {"490":"31d967b6fb66de33","2596":"6df4fc5bda877fd9","5279":"9d6b43bb4d8ee917","6925":"8c51e6d57cbb1675","7229":"8a708ea25dc63f23","8537":"7e5c6ae61ed9bc74"}[chunkId] + ".js";
};